<template>
	<div>
		<div class="tab-list">
			<div class="tab-tooltip row">
				<b-col cols="12" lg="6" class="d-block d-md-none">
					<span class="title"
						>{{ $t('userDashboard.userManage.alllistings') }} {{ itemCount }}
						{{ $t('listing.title') }}</span
					>
				</b-col>
				<b-col cols="12" lg="6">
					<div class="wrap-input-search">
						<b-form-input
							v-model="searchKeywords"
							@input="submitSearch"
							class="input-search"
							:placeholder="$t('userDashboard.userManage.inputSearch')"
						></b-form-input>
					</div>
				</b-col>
				<b-col cols="12" lg="6">
					<div class="group-btn">
						<b-button
							@click="changeTypeViewAlllistings('grid')"
							id="changeViewTypeGrid"
							class="btn-grid"
							v-bind:class="{
								active: typeViewAlllistings == 'grid'
							}"
						>
							<ListGridIcon />
						</b-button>
						<b-button
							@click="changeTypeViewAlllistings('list')"
							id="changeViewTypeList"
							class="btn-list"
							v-bind:class="{
								active: typeViewAlllistings == 'list'
							}"
						>
							<FormatListBulletedIcon />
						</b-button>
						<b-dropdown class="input-choose" no-flip>
							<template v-slot:button-content>
								<span>
									{{ selectedSortBy.name }}
									<ChevronDownIcon />
								</span>
							</template>
							<b-dropdown-item
								v-for="(value, key) in sortBy"
								:key="key"
								@click="selectedSortBy = value"
								>{{ value.name }}</b-dropdown-item
							>
						</b-dropdown>
					</div>
				</b-col>
			</div>
			<div
				v-if="typeViewAlllistings == 'list'"
				class="wrap-list list-all-listings"
			>
				<b-table
					responsive
					sticky-header
					:fields="fields"
					:items="items"
					:tbody-tr-class="tbodyTrClass"
				>
					<template v-slot:cell(avatar)>
						<b-avatar
							:size="48"
							class="bg-transparent"
							src="/images/avatar.png"
						></b-avatar>
					</template>
					<template v-slot:cell(listing)="data">
						<div>
							<div
								class="tb-title"
								style="font-family: 'Prompt Semibold';font-size: 18px;color: #444444;"
							>
								{{ funcSubString(data.item.listing, 50) }}
							</div>
							<div style="font-size:14px; color: var(--projectPrimaryColor);">
								{{ data.item.province }}
								<IconArrowRight
									v-if="data.item.district"
									style="width: 16px;"
								/>
								{{ data.item.district }}
							</div>
						</div>
					</template>
					<template v-slot:cell(status)="data">
						<div
							v-if="
								!data.item.expired == 1 &&
									data.item.status == 1 &&
									data.item.is_approved &&
									!data.item.unapproval_message
							"
						>
							{{ $t('userDashboard.userManage.publish') }}
						</div>
						<div
							v-if="
								!data.item.expired == 1 &&
									data.item.status == 5 &&
									data.item.status == 4
							"
						>
							{{
								data.item.status == 5
									? $t('userDashboard.userManage.setting.sold')
									: $t('rented')
							}}
						</div>
						<div v-if="data.item.status == 0">
							{{ $t('userDashboard.userManage.unconfirmed') }}
						</div>
						<div
							v-else-if="
								data.item.status == 1 &&
									!data.item.is_approved &&
									!data.item.unapproval_message
							"
						>
							{{ $t('userDashboard.userManage.checking') }}
						</div>
						<div v-if="data.item.expired == 1">
							{{ $t('userDashboard.userManage.fieldsExpired.expire') }}
						</div>
						<div v-if="!data.item.expired && data.item.status == 2">
							{{ $t('userDashboard.userManage.disapproval') }}
						</div>
						<div class="paid-promote-option">
							<div
								v-if="
									checkExistPackage('ThairathPackage', data.item.user_payments)
								"
								style="width:100px;height:100px;z-index:9;
											position: absolute;
											top: 20px;right: 0;padding-left: 50px;cursor:pointer"
							>
								<div
									style="
											color: white;
											width: 33px;
											height: 32px;
											display: -webkit-box;
											display: -ms-flexbox;
											display: flex;
											-webkit-box-pack: center;
											-ms-flex-pack: center;
											justify-content: center;
											background: var(--projectPrimaryColor);border-radius: 50%;
											align-items: center;"
								>
									<IconHome style="height: 1em; width: 1em;color:white;" />
								</div>
							</div>
							<div
								v-if="checkExistPackage('Feature', data.item.user_payments)"
								class="bookmark"
							>
								<div class="start-while">
									<StarIcon />
								</div>
							</div>
							<div
								v-if="checkExistPackage('QuickSale', data.item.user_payments)"
								class="hot"
							>
								<div>
									{{ $t('approveListing.quickSale') }}
								</div>
							</div>
							<b-button
								v-if="checkExistPackage('Negotiable', data.item.user_payments)"
								class="btn-negotiable"
								>{{ $t('packages.negotiable.title') }}</b-button
							>
							<div
								v-if="checkExistPackage('Bumpup', data.item.user_payments)"
								class="bump-up"
							>
								<ChevronDoubleUpIcon />
							</div>
							<div
								v-if="checkExistPackage('Website', data.item.user_payments)"
								class="bump-up"
							>
								<MonitorIcon />
							</div>
						</div>
					</template>
					<template v-slot:cell(expire_date)="data">
						<div>
							{{
								data.item.expire_date ? formatDate(data.item.expire_date) : '-'
							}}
						</div>
					</template>

					<template
						v-if="filterListing === 'Rejected'"
						v-slot:cell(view)="data"
					>
						<div
							class="unapproval-link"
							@click="showSuggestions(data.item.unapproval_message)"
						>
							{{ data.item.unapproval_message }}
						</div>
					</template>
					<template v-else v-slot:cell(view)="data">
						<div>{{ data.item.view }}</div>
					</template>

					<template
						v-if="filterListing !== 'Favorite'"
						v-slot:cell(tooltip)="data"
					>
						<b-dropdown size="small" dropright variant="link" no-caret no-flip>
							<template v-slot:button-content>
								<IconSetting />
							</template>
							<b-dropdown-item
								v-if="data.item.status == 2"
								@click="showSuggestions(data.item.unapproval_message)"
								href="#"
								class="icon-bg-primary"
								><EyeIcon />&ensp;{{
									data.item.unapproval_message
										? data.item.unapproval_message.substring(0, 15) + ' ...'
										: 0
								}}</b-dropdown-item
							>
							<b-dropdown-item
								v-if="data.item.status != 2"
								@click="previewAddListing(data.item.id)"
								class="icon-bg-primary"
								><EyeIcon />&ensp;{{
									$t('userDashboard.userManage.setting.view')
								}}</b-dropdown-item
							>
							<b-dropdown-item
								:to="$i18nRoute({ name: 'edit-listing' }) + data.item.id"
								v-if="data.item.status != 5"
								class="icon-bg-primary"
								><EditIcon />&ensp;{{
									$t('userDashboard.userManage.setting.edit')
								}}</b-dropdown-item
							>
							<b-dropdown-item
								v-if="
									data.item.show_renew == 1 &&
										data.item.status != 2 &&
										data.item.status != 5
								"
								@click="renewListing(data.item.id)"
								class="icon-bg-primary"
								><RepeatOulineIcon />&ensp;{{
									$t('userDashboard.userManage.setting.renew')
								}}</b-dropdown-item
							>
							<b-dropdown-item
								v-if="data.item.status != 2 && data.item.status != 5"
								class="icon-bg-primary"
								@click="goToPromoteOption(data.item.id)"
								><VolumIcon />&ensp;{{
									$t('userDashboard.userManage.setting.promote')
								}}</b-dropdown-item
							>
							<b-dropdown-item
								v-if="
									data.item.status != 2 &&
										data.item.status != 5 &&
										data.item.is_approved
								"
								class="icon-eye-off"
								@click="eyeOffItem(data.item)"
								><IconEyeOff />&ensp;{{
									$t('userDashboard.userManage.setting.sold')
								}}{{
									data.item.parentCategoryId == 2 ? `/${$t('rented')}` : ''
								}}</b-dropdown-item
							>
							<b-dropdown-item
								class="icon-bg-danger"
								@click="deletedItem(data.item.listing, data.item.id)"
								><TrashIcon />&ensp;{{
									$t('userDashboard.userManage.setting.delete')
								}}</b-dropdown-item
							>
						</b-dropdown>
					</template>
					<template v-else v-slot:cell(tooltip)="data">
						<div class="dislike" @click="deleteFavourites(data.item.id)">
							<FavoriteIcon />
							{{ $t('dislike') }}
						</div>
					</template>
				</b-table>

				<b-row class="d-flex d-md-none">
					<template v-for="(item, index) in items">
						<b-col cols="12" :key="index">
							<ItemViewMobile
								:isFeature="item.isFeature"
								:isHighlight="item.isHighlight"
								:isNegotiable="item.isNegotiable"
								:isQuickSale="item.isQuickSale"
								:url-image="item.img_url"
								:province="item.province"
								:district="item.district"
								:title="item.listing"
								:price="item.price"
								:salaryType="item.salaryType"
								:minSalary="item.minSalary ? item.minSalary : 0"
								:id="item.id"
								:status="item.status"
								:is_approved="item.is_approved"
								:show_renew="item.show_renew"
								:unapproval_message="item.unapproval_message"
								:parentCategoryId="item.parentCategoryId"
								:name="item.name"
								@funcSetting="showModalSetting"
							/>
						</b-col>
					</template>
				</b-row>
				<infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
					<span slot="no-results"
						><b-alert show variant="light" v-if="!items.length">{{
							$t('userDashboard.userManage.noAnnoucement')
						}}</b-alert></span
					>
					<span slot="no-more"></span>
				</infinite-loading>
			</div>
			<div
				v-else-if="typeViewAlllistings == 'grid'"
				class="grid-all-listings pd-0"
			>
				<div class="wrap-scroll">
					<div class="wrap-scroll-message">
						<b-row style="margin:0">
							<template v-for="(item, key) in items">
								<b-col :key="key" cols="12" sm="6" md="6" lg="4" class="mb-20">
									<b-card no-body class="card-item">
										<b-row no-gutters>
											<b-col md="12">
												<router-link
													id="listingDetail"
													:event="item.is_approved ? 'click' : ''"
													:style="
														item.is_approved ? null : { cursor: 'default' }
													"
													:to="$i18nRoute({ name: 'listing-detail' }, item.id)"
												>
													<b-card-img
														v-if="item.img_url"
														:src="item.img_url.replace('832x468', '250x141')"
														class="img-card"
													></b-card-img>
													<div class="status-listing">
														<span v-if="item.status == 0">
															{{ $t('userDashboard.userManage.unconfirmed') }}
														</span>
														<span
															v-else-if="
																item.status == 1 &&
																	!item.is_approved &&
																	!item.unapproval_message
															"
														>
															{{ $t('userDashboard.userManage.checking') }}
														</span>
														<span
															v-if="
																!item.expired == 1 &&
																	(item.status == 5 || item.status == 4) &&
																	item.is_approved
															"
														>
															{{
																item.status == 5
																	? $t('userDashboard.userManage.setting.sold')
																	: $t('rented')
															}}</span
														>
														<span
															v-if="item.expired == 1 && item.is_approved"
															>{{
																$t(
																	'userDashboard.userManage.fieldsExpired.expire'
																)
															}}</span
														>
														<span v-if="!item.expired && item.status == 2">{{
															$t('userDashboard.userManage.disapproval')
														}}</span>
													</div>
												</router-link>
												<div
													v-if="
														item.unapproval_message &&
															(filterListing === 'All' ||
																filterListing === 'Rejected')
													"
													@click="showSuggestions(item.unapproval_message)"
													style="width:100px;height:100px;z-index:9;
															position: absolute;
															top: 20px;right: 0;padding-left: 50px;cursor:pointer"
												>
													<div
														style="
															color: white;
															width: 33px;
															height: 32px;
															display: -webkit-box;
															display: -ms-flexbox;
															display: flex;
															-webkit-box-pack: center;
															-ms-flex-pack: center;
															justify-content: center;
															background: #EBAC00;border-radius: 50%;"
													>
														<MessageOutlineIcon />
													</div>
												</div>
												<div
													v-if="
														checkExistPackage(
															'ThairathPackage',
															item.user_payments
														)
													"
													style="width:100px;height:100px;z-index:9;
															position: absolute;
															top: 20px;right: 0;padding-left: 50px;cursor:pointer"
												>
													<div
														style="
															color: white;
															width: 33px;
															height: 32px;
															display: -webkit-box;
															display: -ms-flexbox;
															display: flex;
															-webkit-box-pack: center;
															-ms-flex-pack: center;
															justify-content: center;
															background: var(--projectPrimaryColor);border-radius: 50%;
															align-items: center;"
													>
														<IconHome
															style="height: 1em; width: 1em;color:white;"
														/>
													</div>
												</div>
												<div v-if="item.isQuickSale" class="hot">
													<div>{{ $t('approveListing.quickSale') }}</div>
												</div>
												<div
													v-if="
														checkExistPackage('Feature', item.user_payments)
													"
													class="bookmark"
												>
													<div class="start-while">
														<StarIcon />
													</div>
												</div>
											</b-col>
											<b-col md="12">
												<b-card-body
													:class="{
														'bg-yellow': item.isHighlight,
														'bg-light-green': item.isFeature
													}"
												>
													<b-card-text class="card-address">
														{{ item.province }} >
														{{ item.district }}
													</b-card-text>
													<b-card-text class="categories-name">
														{{ item.listing }}
													</b-card-text>
													<b-card-text class="card-cost">
														<!--job category-->
														<span v-if="!item.salaryType">
															<span v-if="item.minSalary">
																{{
																	item.minSalary
																		? item.minSalary + $t('baht')
																		: ''
																}}
																-
															</span>
															{{ item.price.toLocaleString('th-TH') }}
															{{ $t('baht') }}
														</span>
														<!--job category-->
														<span class="card-cost" v-if="item.salaryType">
															{{ item.salaryType }}
														</span>
														<div
															v-if="filterListing === 'Favorite'"
															class="card-favorite"
															@click="deleteFavourites(item.id)"
														>
															<FavoriteIcon />
														</div>
													</b-card-text>
												</b-card-body>
											</b-col>
										</b-row>
										<div
											v-if="filterListing !== 'Favorite'"
											class="card-setting"
										>
											<span
												class="icon-setting-mobile"
												@click="showModalSetting(item)"
											>
												<IconSetting />
											</span>
											<b-dropdown
												no-flip
												size="small"
												dropright
												variant="link"
												no-caret
											>
												<template v-slot:button-content>
													<IconSetting />
												</template>
												<b-dropdown-item
													v-if="item.status == 2"
													@click="showSuggestions(item.unapproval_message)"
													href="#"
													class="icon-bg-primary"
													><EyeIcon />&ensp;{{
														item.unapproval_message
															? item.unapproval_message.substring(0, 15) +
															  ' ...'
															: 0
													}}</b-dropdown-item
												>
												<b-dropdown-item
													v-if="item.status != 2"
													@click="previewAddListing(item.id)"
													class="icon-bg-primary"
													><EyeIcon />&ensp;{{
														$t('userDashboard.userManage.setting.view')
													}}</b-dropdown-item
												>
												<b-dropdown-item
													:to="
														$i18nRoute({
															name: 'edit-listing'
														}) + item.id
													"
													v-if="item.status != 5"
													class="icon-bg-primary"
													><EditIcon />&ensp;{{
														$t('userDashboard.userManage.setting.edit')
													}}</b-dropdown-item
												>
												<b-dropdown-item
													v-if="
														item.show_renew == 1 &&
															item.status != 2 &&
															item.status != 5
													"
													class="icon-bg-primary"
													@click="renewListing(item.id)"
													><RepeatOulineIcon />&ensp;{{
														$t('userDashboard.userManage.setting.renew')
													}}</b-dropdown-item
												>
												<b-dropdown-item
													v-if="item.status != 2 && item.status != 5"
													class="icon-bg-primary"
													@click="goToPromoteOption(item.id)"
													><VolumIcon />&ensp;{{
														$t('userDashboard.userManage.setting.promote')
													}}</b-dropdown-item
												>
												<b-dropdown-item
													v-if="
														item.status != 2 &&
															item.status != 5 &&
															item.is_approved
													"
													@click="eyeOffItem(item)"
													class="icon-eye-off"
													><IconEyeOff />&ensp;{{
														$t('userDashboard.userManage.setting.sold')
													}}{{
														item.parentCategoryId == 2 ? `/${$t('rented')}` : ''
													}}</b-dropdown-item
												>

												<!--  -->

												<b-dropdown-item
													class="icon-bg-danger"
													@click="deletedItem(item.listing, item.id)"
													><TrashIcon />&ensp;{{
														$t('userDashboard.userManage.setting.delete')
													}}</b-dropdown-item
												>
											</b-dropdown>
										</div>
									</b-card>
								</b-col>
							</template>
						</b-row>
						<infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
							<span slot="no-results"
								><b-alert show variant="light" v-if="!items.length">{{
									$t('userDashboard.userManage.noAnnoucement')
								}}</b-alert></span
							>
							<span slot="no-more"></span>
						</infinite-loading>
					</div>
				</div>
			</div>
		</div>
		<b-modal
			id="modal-close-listing-sold-rent"
			centered
			hide-header
			hide-footer
			v-model="showListingClosingDialog"
			size="md"
			v-if="selectedListing"
		>
			<div
				@click="showListingClosingDialog = false"
				class="d-flex flex-row close-modal justify-content-end align-self-end"
			>
				<CloseIcon />
			</div>

			<div class="d-flex flex-column justify-content-center align-self-center">
				<div style="font-size:20px;color:#626262; width: 55%;margin: 0 auto;">
					{{
						$t(
							'for the improvement of the website Please answer the questionnaire below'
						)
					}}
				</div>
				<b-form-group class="mt-4 ml-5">
					<b-form-radio-group
						id="radio-group-2"
						v-model="selectedClosingOption"
						name="radio-sub-component"
						stacked
					>
						<b-form-radio
							:value="'Sold through affiliate Buy-Sell'"
							class="mb-2"
							>{{
								$t('Sold through affiliate Buy-Sell', {
									affiliate: $root.affiliate
								})
							}}</b-form-radio
						>
						<b-form-radio
							:value="'Sold through another website'"
							class="mb-2"
							>{{ $t('Sold through another website') }}</b-form-radio
						>
						<b-form-radio :value="'cancel the sale'" class="mb-2">{{
							$t('cancel the sale')
						}}</b-form-radio>
						<b-form-radio :value="'other'" class="mb-2">{{
							$t('other')
						}}</b-form-radio>
					</b-form-radio-group>
					<b-form-textarea
						v-if="selectedClosingOption == 'other'"
						v-model="closeingText"
						rows="3"
						max-rows="6"
					></b-form-textarea>
				</b-form-group>
				<b-button
					class="mt-3 md-3"
					@click="closeListing()"
					style="width: 100px;height: 40px;border-radius: 40px; margin:0 auto;"
				>
					{{
						selectedListing && selectedListing.parentCategoryId == 2
							? $t('rented')
							: $i18n.t('userDashboard.userManage.modal.btnConfirm')
					}}
				</b-button>
			</div>
		</b-modal>
		<b-modal
			v-if="itemMobileSelected"
			id="modal-setting"
			centered
			hide-header
			hide-footer
			v-model="modalShowSetting"
		>
			<b-row>
				<b-col cols="6">
					<p class="box-icon">
						<router-link
							id="listingDetail"
							:event="itemMobileSelected.is_approved ? 'click' : ''"
							:style="
								itemMobileSelected.is_approved ? null : { cursor: 'default' }
							"
							:to="
								$i18nRoute({ name: 'listing-detail' }, itemMobileSelected.id)
							"
						>
							<span><EyeIcon /></span>
						</router-link>
					</p>
					<p>
						{{ $t('userDashboard.userManage.setting.view') }}
					</p>
				</b-col>
				<b-col cols="6" v-if="itemMobileSelected.status != 5">
					<p class="box-icon">
						<router-link
							id="editListing"
							:to="$i18nRoute({ name: 'edit-listing' }, itemMobileSelected.id)"
						>
							<span><EditIcon /></span>
						</router-link>
					</p>
					<p>
						{{ $t('userDashboard.userManage.setting.edit') }}
					</p>
				</b-col>
				<b-col
					cols="6"
					v-if="
						itemMobileSelected.show_renew == 1 &&
							itemMobileSelected.status != 2 &&
							itemMobileSelected.status != 5
					"
				>
					<p class="box-icon">
						<span @click="renewListing(itemMobileSelected.id)"
							><RepeatOulineIcon
						/></span>
					</p>
					<p>
						{{ $t('userDashboard.userManage.setting.renew') }}
					</p>
				</b-col>
				<!-- <b-col cols="6" >
                            <p class="box-icon">
                              <span @click="showNotify"
                                ><RepeatOulineIcon
                              /></span>
                            </p>
                            <p>
                             sasasa {{ $t("userDashboard.userManage.setting.renew") }}
                            </p>
                          </b-col> -->
				<b-col cols="6" v-if="itemMobileSelected.status == 2">
					<p class="box-icon">
						<span
							@click="showSuggestions(itemMobileSelected.unapproval_message)"
							><EyeIcon />&ensp;{{
								itemMobileSelected.unapproval_message
									? itemMobileSelected.unapproval_message.substring(0, 15) +
									  ' ...'
									: 0
							}}</span
						>
					</p>
				</b-col>
				<b-col
					cols="6"
					v-if="
						itemMobileSelected.status != 2 && itemMobileSelected.status != 5
					"
				>
					<p class="box-icon">
						<span @click="goToPromoteOption(itemMobileSelected.id)"
							><VolumIcon
						/></span>
					</p>
					<p>
						{{ $t('userDashboard.userManage.setting.promote') }}
					</p>
				</b-col>
				<b-col
					cols="6"
					v-if="
						itemMobileSelected.status != 2 &&
							itemMobileSelected.status != 5 &&
							itemMobileSelected.is_approved
					"
				>
					<p class="box-icon icon-eye-off">
						<span @click="eyeOffItem(itemMobileSelected)"><IconEyeOff /></span>
					</p>
					<p>
						{{ $t('userDashboard.userManage.setting.sold')
						}}{{
							itemMobileSelected.parentCategoryId == 2 ? `/${$t('rented')}` : ''
						}}
					</p>
				</b-col>
				<b-col cols="6">
					<p class="box-icon icon-trash">
						<span
							@click="
								deletedItem(itemMobileSelected.name, itemMobileSelected.id)
							"
							><TrashIcon
						/></span>
					</p>
					<p>
						{{ $t('userDashboard.userManage.setting.delete') }}
					</p>
				</b-col>
			</b-row>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import moment from 'moment';

import ItemViewMobile from '@/components/itemViewMobile/index';
import InfiniteLoading from 'vue-infinite-loading';
// Icons
import FormatListBulletedIcon from 'vue-material-design-icons/FormatListBulleted.vue';

import FavoriteIcon from 'vue-material-design-icons/Heart.vue';
import ListGridIcon from '@/components/icons/IconListGrid/index';
import EyeIcon from '@/components/icons/IconEye/index';
import EditIcon from '@/components/icons/IconEdit/index';
import VolumIcon from '@/components/icons/IconVolum/index';
import TrashIcon from '@/components/icons/IconTrash/index';
import IconSetting from '@/components/icons/IconSetting/index';
import IconHome from '@/components/icons/IconHome/index';
import IconEyeOff from '@/components/icons/IconEyeOff/index';
import StarIcon from 'vue-material-design-icons/Star.vue';
import RepeatOulineIcon from '@/components/icons/IconRepeat/index';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import ChevronDoubleUpIcon from 'vue-material-design-icons/ChevronDoubleUp.vue';
import MessageOutlineIcon from 'vue-material-design-icons/MessageOutline.vue';
import MonitorIcon from 'vue-material-design-icons/Monitor.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';

export default {
	components: {
		FormatListBulletedIcon,
		ListGridIcon,
		EyeIcon,
		EditIcon,
		VolumIcon,
		TrashIcon,
		StarIcon,
		IconSetting,
		IconEyeOff,
		RepeatOulineIcon,
		FavoriteIcon,
		ChevronDownIcon,
		ItemViewMobile,
		InfiniteLoading,
		ChevronDoubleUpIcon,
		MessageOutlineIcon,
		MonitorIcon,
		IconHome,
		CloseIcon
	},

	props: {
		filterListing: {
			type: String,
			default: 'All'
		},
		items: {
			type: Array
		}
	},

	data() {
		return {
			itemCount: 0,
			selectedClosingOption: 'Sold through affiliate Buy-Sell',
			closeingText: null,
			fields: [
				{
					key: 'avatar',
					label: this.$i18n.t(
						'userDashboard.userManage.fieldsAllListing.listing'
					),
					tdClass: 'tb-avatar align-middle'
				},
				{
					key: 'listing',
					label: '',
					tdClass: 'align-middle'
				},
				{
					key: 'status',
					label: this.$i18n.t(
						'userDashboard.userManage.fieldsAllListing.status'
					),
					tdClass: 'align-middle'
				},
				{
					key: 'expire_date',
					label: this.$i18n.t(
						'userDashboard.userManage.fieldsAllListing.expire'
					),
					tdClass: 'align-middle'
				},
				{
					key: 'view',
					label:
						this.filterListing !== 'Rejected'
							? this.$i18n.t('userDashboard.userManage.fieldsAllListing.view')
							: this.$i18n.t(
									'userDashboard.userManage.fieldsFailTheCheck.suggestions'
							  ),
					tdClass:
						this.filterListing !== 'Rejected'
							? 'align-middle'
							: 'tb-suggestions align-middle'
				},
				{
					key: 'tooltip',
					label: '',
					tdClass: 'tb-tooltip align-middle'
				}
			],
			selectedSortBy: {
				value: 'Visitor',
				name: this.$i18n.t('userDashboard.userManage.fillter.visitor')
			},
			sortBy: [
				{
					value: 'Visitor',
					name: this.$i18n.t('userDashboard.userManage.fillter.visitor')
				},
				{
					value: 'Latest',
					name: this.$i18n.t('userDashboard.userManage.fillter.latestListing')
				},
				{
					value: 'PriceHigh',
					name: this.$i18n.t('userDashboard.userManage.fillter.priceHigh')
				},
				{
					value: 'PriceLow',
					name: this.$i18n.t('userDashboard.userManage.fillter.priceLow')
				},
				{
					value: 'Rented',
					name: this.$t('rented')
				},
				{
					value: 'Sold',
					name: this.$t('Sold')
				}
			],
			typeViewAlllistings: 'grid',
			modalShowSetting: false,
			showListingClosingDialog: false,
			searchKeywords: null,
			listingSortBy: 'Visitor',
			timer: null,
			loading: false,
			itemMobileSelected: null,
			selectedListing: null,
			config: {
				limit: 10,
				take: 0,
				page: 1
			}
		};
	},
	computed: {
		...mapState('UserListingController', ['isSoldListing', 'isDeleteListing'])
	},
	watch: {
		isSoldListing: function(val) {
			if (val) {
				this.resetUserListing();
			}
		},
		isDeleteListing: function(val) {
			if (val) {
				this.resetUserListing();
			}
		},
		'selectedSortBy.value': function(val) {
			this.resetUserListing();
		},
		filterListing: function(val) {
			this.resetUserListing();
		},
		items(val) {}
	},
	methods: {
		...mapActions('UserListingController', [
			'GET_USER_LISTING',
			'SOLD_LISTING',
			'DELETE_LISTING',
			'RENEW_LISTING'
		]),
		...mapActions('FavouriteController', ['DELETE_FAVOURITES_USER']),
		...mapActions('AddListingController', ['GET_LISTING_PREVIEW']),

		changeTypeViewAlllistings(type) {
			this.typeViewAlllistings = type;
		},
		showModalSetting(item) {
			this.modalShowSetting = !this.modalShowSetting;
			this.itemMobileSelected = item;
		},
		goToPromoteOption(id) {
			this.$router.push(this.$i18nRoute({ name: 'packages-screen' }) + id);
		},
		eyeOffItem(listing) {
			this.modalShowSetting = false;
			this.showListingClosingDialog = true;
			this.selectedListing = listing || null;
		},
		closeListing() {
			if (this.selectedListing) {
				if (this.selectedListing.parentCategoryId == 2) {
					this.SOLD_LISTING({
						id: this.selectedListing.id,
						status: 4,
						motive:
							this.selectedClosingOption == 'other'
								? this.closeingText
								: this.selectedClosingOption
					});
				} else {
					this.SOLD_LISTING({
						id: this.selectedListing.id,
						status: 5,
						motive:
							this.selectedClosingOption == 'other'
								? this.closeingText
								: this.selectedClosingOption
					});
				}
			}
		},
		deletedItem(name, id) {
			this.$swal({
				title: this.$i18n.t('userDashboard.userManage.modalDelete.title'),
				text: name,
				customClass: {
					container: 'swal-del-item'
				},
				showCancelButton: true,
				cancelButtonColor: 'var(--projectPrimaryColor)',
				confirmButtonColor: '#DC3849',
				cancelButtonText: this.$i18n.t(
					'userDashboard.userManage.modal.btnConfirm'
				),
				confirmButtonText: this.$i18n.t(
					'userDashboard.userManage.modal.btnCancel'
				),
				preConfirm: () => {
					this.DELETE_LISTING(id);
					this.modalShowSetting = false;
				}
			});
		},
		showSuggestions(suggest) {
			this.$swal({
				title: this.$i18n.t('userDashboard.userManage.modalSuggestion.title'),
				text: suggest,
				customClass: {
					container: 'swal-suggest'
				},
				confirmButtonColor: 'var(--projectPrimaryColor)',
				confirmButtonText: this.$i18n.t(
					'userDashboard.userManage.modalSuggestion.btnConfirm'
				)
			});
		},
		formatDate(date) {
			return moment(date)
				.locale('th')
				.format('DD MMM YYYY');
		},
		infiniteHandler($state) {
			if (this.config.take !== this.itemCount || this.config.take === 0) {
				this.GET_USER_LISTING({
					take: this.config.limit,
					page: this.config.page,
					search: this.searchKeywords,
					fillter: this.filterListing,
					sort_by: this.selectedSortBy.value
				})
					.then(async result => {
						if (result.data.data.length > 0) {
							this.itemCount = result.data.meta.itemCount;
							if (
								result.data.data.length < this.config.limit ||
								this.items.length === result.data.meta.itemCount
							) {
								this.config.take += result.data.data.length;
								return await $state.complete();
							}
							this.config.page += 1;
							this.config.take += result.data.data.length;
							await $state.loaded();
						} else {
							await $state.complete();
						}
					})
					.catch(error => {});
			} else {
				$state.complete();
			}
		},
		resetUserListing() {
			this.$emit('resetItems');
			this.config.take = 0;
			this.config.page = 1;
			this.$nextTick(() => {
				this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
			});
		},
		submitSearch(e) {
			const _this = this;
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
			this.timer = setTimeout(() => {
				_this.resetUserListing();
			}, 600);
		},
		deleteFavourites(id) {
			this.DELETE_FAVOURITES_USER({
				id: id
			}).then(result => {
				if (result.data.success) {
					this.resetUserListing();
				}
			});
		},
		previewAddListing(id) {
			if (id) {
				this.GET_LISTING_PREVIEW(id);
			}
		},
		tbodyTrClass(items) {
			if (items.isFeature) {
				return 'hidden_header_featured_active';
			} else if (items.isHighlight) {
				return 'hidden_header_active';
			}
			return '';
		},
		funcSubString(string, number) {
			let subStr = '';
			if (string.length > number && string.indexOf(' ') !== -1) {
				subStr =
					string.substring(0, string.substring(0, number).lastIndexOf(' ')) +
					' ...';
			} else {
				subStr = string;
			}
			return subStr.toString();
		},
		renewListing(id) {
			const _this = this;
			this.$swal({
				title: this.$t('Do you want to renew the announcement'),
				text: id,
				customClass: {
					container: 'swal-del-item'
				},
				showCancelButton: true,
				cancelButtonColor: 'var(--projectPrimaryColor)',
				confirmButtonColor: '#DC3849',
				cancelButtonText: this.$i18n.t(
					'userDashboard.userManage.modal.btnCancel'
				),
				confirmButtonText: this.$i18n.t(
					'userDashboard.userManage.modal.btnConfirm'
				)
			}).then(result => {
				if (result.dismiss == 'cancel') {
					if (id) {
						_this
							.RENEW_LISTING(id)
							.then(item => {
								_this.modalShowSetting = false;
								_this.resetUserListing();
							})
							.catch(error => {
								_this.modalShowSetting = false;
								_this.resetUserListing();
							});
					}
				}
			});
		},
		checkExistPackage(type, user_payments) {
			switch (type) {
				case 'Feature':
					let existFeature = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail.package_id === 1) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existFeature;
					break;
				case 'Bumpup':
					let existBumpup = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (
								temp.packages_detail.package_id === 1 ||
								temp.packages_detail.package_id === 2
							) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existBumpup;
					break;
				case 'QuickSale':
					let existQuickSale = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail.package_id === 3) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existQuickSale;
					break;
				case 'Negotiable':
					let existNegotiable = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail.package_id === 4) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existNegotiable;
					break;
				case 'Highlight':
					let existHighlight = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (
								temp.packages_detail.package_id === 1 ||
								temp.packages_detail.package_id === 5
							) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existHighlight;
					break;
				case 'Website':
					let existWebsite = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail.package_id === 6) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existWebsite;
					break;
				case 'ThairathPackage':
					let ThairathPackage = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail.package_id === 7) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!ThairathPackage;
					break;
			}
			return false;
		}
	}
};
</script>

<style lang="scss">
@import 'userManageListing.scss';
</style>
